/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-10 17:09:43
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * @description 获取二维码提交内容
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  getQRCode(data) {
    return request.post(`/${BASE_URL}/mission/store`, data)
  },
   /**
   * @description 获取二维码图片
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  createQrcode(data) {
    return request.post(`/${BASE_URL}/mission/create_qrcode`, data)
  },
  /**
   * getMixinRechargeList
   * @description 获取任务列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getMissionList(data) {
    return request.post(`/${BASE_URL}/mission/list`, data)
  },
  /**
   * getMixinWithDrawList
   * @description 修改任务保存状态
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getMissionSaveStatus(data) {
    return request.post(`/${BASE_URL}/mission/change_status`, data)
  }
}